import { useAdminI18n } from '@/lib/i18n/use-admin-i18n';

export function SystemConfigPage() {
  const { page } = useAdminI18n();

  return (
    <div className="space-y-2">
      <div>
        <h1 className="text-3xl font-bold">{page('system_config', 'title')}</h1>
        <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">{page('system_config', 'subtitle')}</p>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
        <div className="text-center py-12">
          <p className="text-gray-500 dark:text-gray-400">
            System configuration will be available once the backend API is implemented.
          </p>
          <p className="text-sm text-gray-400 dark:text-gray-500 mt-2">Coming soon...</p>
        </div>
      </div>
    </div>
  );
}

